import React from "react";
import UserListModal from "./UserListModal";
import { MODAL_IDS } from "./profile-constants";

function FollowersModal({ users, isOpen, onClose }) {
  return (
    <UserListModal
      id={MODAL_IDS.FOLLOWERS}
      title="Стежать"
      ariaLabel="Список підписників"
      users={users}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}

export default FollowersModal;
